import * as React from "react";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import {ITabReduxItem} from "../../../../redux/types/ITabReduxItem";
import {ILookupDictionary} from "../../../../lookup/types/ILookupDictionary";
import {IRepertoireField} from "../../../types/IRepertoireField";
import ActionButton, {
    ActionButtonFormik,
    InlineActionButton,
    SizedActionButton,
    WideActionButton
} from "../../../components/actionButton/ActionButton";
import TextDataInput, {SizedTextDataInput} from "../../../components/textDataInput/TextDataInput";
import {
    IP_STATUS_STATE_KEY,
    LAST_MODIFIED_DATE_STATE_KEY,
    NOTE_KEY,
    CLEAR_PACKAGE_BUTTON,
    GENERATE_FILE_PACKAGE,
    LASTMODIFIED_DATE_KEY,
    ITEM_COUNT_KEY,
    DOWNLOAD_FILE_FORMAT_KEY,
    SAVE_PACKAGE_BUTTON,
    PACKAGE_ID_KEY,
    NOTE_PLACEHOLDER,
    SELECT,
    FULL_CATALOGUE_TEXT
} from "../../../Consts";
import {Form} from "reactstrap";
import DropdownDataInput, {SizedDropdownDataInput} from "../../../components/dropdownDataInput/DropdownDataInput";
import {IMyPackagesDetails} from "../../../types/IMyPackagesDetails";
import {EntityType} from "../../../types/EntityType";
import moment from "moment";
import { UPLOAD_BULK_WORKS_PAGE_VIEW } from "../../../../membersportal/Consts";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import ScrollEventListenerWrapperContainerDetailsWindow from "../../../../dataingestion/components/containerDetailsWindow/ScrollEventListenerWrapperContainerDetailsWindow";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { addFileToUpload, CleanUploadFilesState, setInDropZone, setProgressUploadFileProccess } from "../../../../redux/reducers/DataIngestionReducer";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
import { ITreeNodeData } from "../../../../treeview/types/TreeNodeData";
import { ITreeData } from "../../../types/ITreeData";
import { DataSource } from "../../../types/DataSource";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import { MATCHING_ENGINE } from "../../../../accounts/Consts";
import { getMandatoryFlag } from "../../../../util/tools";

export interface MyPackagesGeneralDataViewProps {
    myPackagesGeneralDataViewData: IRepertoireComponentDataItem;
    isReadonly: boolean;
    lookupValues: ILookupDictionary;
    editableFields: IRepertoireField[];
    DownloadFileFormats: string[];
    clearPackages?: (myPackages: IMyPackagesDetails) => void;
    myPackagesResult?: any;
    headerType?: string;
    getMyPackagesDetails?: (userName: string, modalOpen: boolean) => void;
    currentUser?: string;
    handleClearPackages: (updatedPackagesData: IMyPackagesDetails[], headerType: string) => void;
    generatePackage?: (myPackage: IMyPackagesDetails) => void;
    closePackage?: (myPackage: IMyPackagesDetails) => void;
    addPackageNote?: (myPackage: IMyPackagesDetails) => void;
    savePackages?: (myPackage: IMyPackagesDetails) => void;
    containerDetailsWindowComponentData?: IComponentDataItem;
    storagePathItemData?: IComponentDataItem;
    destinations?: ILookupInstance[];
    droppedFiles?: any;
    isDropZone?: boolean;
    selectedFileSystem?: IFileSystem;
    treeNodes?: ITreeNodeData<IFileSystem>[];
    getDataIngestionComponentData?: (componentName: string, componentInstance: string) => void;
    addFileToUpload?: typeof addFileToUpload;
    cleanUploadFilesState?: typeof CleanUploadFilesState;
    setInDropZone?: typeof setInDropZone;
    setProgressUploadFileProccess?: typeof setProgressUploadFileProccess;
    refreshDirectory?: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState?: (attachedFile: IAttachedFile) => void;
    removeAttachmentIfExists?: (attachedFile: IAttachedFile, source: DataSource) => void;
    filesDropped?: IDroppedFiles;
    portalType?: string;
    fullCataloguePackagePending?: boolean;
    packageOperationInProgress?: boolean;
}

interface MyPackagesGeneralDataViewState {
    loaded: boolean;
    selectedFormat?: string;
    lastModifiedDate?: string;
    packageItemsCount?: number;
    myPackagesResult?: IMyPackagesDetails[];
    note: string;
    packageId?: string;
    disablebtn?: boolean;
    disableSavebtn?: boolean;
    disableClearbtn?: boolean;
}

export default class MyPackagesGeneralDataView extends React.PureComponent<
    MyPackagesGeneralDataViewProps,
    MyPackagesGeneralDataViewState
> {
    viewData;
    onClickSearch: () => void;

    constructor(props: MyPackagesGeneralDataViewProps) {
        super(props);
        this.state = {
            loaded: false,
            note: "",
            packageId: "",
            disablebtn: false,
            disableSavebtn: false,
            disableClearbtn: false,
        };
        this.viewData = {};
    }

    componentDidMount() {
        this.processData(this.props.myPackagesGeneralDataViewData);
        const filteredData = this.getInitialPackageData(this.props.headerType);
        const {DownloadFileFormats} = this.props;
        const hasFullCatalogue = Boolean(filteredData?.[0]?.searchCriteriaJson);

        if (filteredData && filteredData.length > 0 && (filteredData[0]?.packageItemsCount > 0 || hasFullCatalogue)) {
            this.setState({
                lastModifiedDate: filteredData[0].lastModifiedDate ? moment(filteredData[0].lastModifiedDate).format("DD/MM/YYYY hh:mm A") : 'N/A',
                packageItemsCount: filteredData[0].packageItemsCount,
                packageId: filteredData[0].id,
                selectedFormat: DownloadFileFormats.length > 0 ? DownloadFileFormats[0] : this.viewData[SELECT],
                disablebtn: filteredData[0] === undefined || (!hasFullCatalogue && filteredData[0]?.packageItemsCount === 0),
                disableSavebtn: (filteredData && filteredData[0]?.packageItemsCount === 0),
                disableClearbtn: (filteredData && filteredData[0] === undefined) || (!hasFullCatalogue && filteredData[0]?.packageItemsCount === 0)
            });
        } else {
            this.setState({
                lastModifiedDate: moment().format("DD/MM/YYYY hh:mm A"),
                packageItemsCount: 0,
                selectedFormat: DownloadFileFormats.length > 0 ? DownloadFileFormats[0] : this.viewData[SELECT],
                disablebtn: true,
                disableSavebtn: true,
                disableClearbtn: true
            });
        }
    }

    private getPackagesData(): IMyPackagesDetails[] {
        const { myPackagesResult } = this.props;
        if (Array.isArray(myPackagesResult)) return myPackagesResult;
        if (Array.isArray(myPackagesResult?.data)) return myPackagesResult.data;
        return [];
    }

    getInitialPackageData(defaultSection) {
        const packages = this.getPackagesData();
        if (packages.length === 0) return undefined;
        return packages
            .filter(x => x.entityType === defaultSection && x.status === "Open")
            .map(packageItem => ({
                lastModifiedDate: packageItem.lastModifiedDate,
                packageItemsCount: (packageItem.packageItems ?? []).length,
                id: packageItem.id,
                note: packageItem.note,
                searchCriteriaJson: packageItem.searchCriteriaJson
            }));
    }

    processData(data) {
        if (data && data.fields) {
            const visibleFields = data.fields.filter(field => !field.hidden);
            visibleFields.forEach(item => {
                this.viewData[item.name] = item.data;
            });

            if (Object.keys(this.viewData).length === visibleFields.length) {
                this.setState({loaded: true});
            }
        }
    }

    onSaveEditableFields = (value, fieldName) => {
        if (fieldName === this.viewData[DOWNLOAD_FILE_FORMAT_KEY]) {
            this.setState({selectedFormat: value});
        } else if (fieldName === NOTE_KEY) {
            this.setState({note: value});
        }
    }

componentDidUpdate(prevProps, prevState) {
    this.processData(this.props.myPackagesGeneralDataViewData);
    const filteredData = this.getInitialPackageData(this.props.headerType);
    const hasFullCatalogue = Boolean(filteredData?.[0]?.searchCriteriaJson);

    const shouldRecalc =
        prevProps.myPackagesResult !== this.props.myPackagesResult ||
        prevProps.headerType !== this.props.headerType ||
        (this.state.note !== prevState.note);

    if (shouldRecalc && !this.props.packageOperationInProgress) {
        if (filteredData && filteredData.length > 0 && (filteredData[0]?.packageItemsCount > 0 || hasFullCatalogue)) {
            this.setState({
                lastModifiedDate: filteredData[0].lastModifiedDate ? moment(filteredData[0].lastModifiedDate).format("DD/MM/YYYY hh:mm A") : 'N/A',
                packageItemsCount: filteredData[0].packageItemsCount,
                packageId: filteredData[0].id,
                note: this.state.note ? this.state.note : (filteredData[0].packageItemsCount !== 0 ? filteredData[0].note : ''),
                disablebtn: filteredData[0] === undefined || (!hasFullCatalogue && filteredData[0]?.packageItemsCount === 0),
                disableSavebtn: (filteredData && filteredData[0]?.packageItemsCount === 0),
                disableClearbtn: (filteredData && filteredData[0] === undefined) || (!hasFullCatalogue && filteredData[0]?.packageItemsCount === 0)
            });
        } else {
            this.setState({
                lastModifiedDate: moment().format("DD/MM/YYYY hh:mm A"),
                packageItemsCount: 0,
                disablebtn: true,
                disableSavebtn: true,
                disableClearbtn: true
            });
        }
    }

}

    clearPackages = () => {
        const { clearPackages, headerType, getMyPackagesDetails, currentUser } = this.props;
        const gridData = this.getPackagesData();
        const section = gridData.filter(x => x.entityType === headerType && x.status === "Open")
        clearPackages(section[0]);

        setTimeout(() => {
            getMyPackagesDetails(currentUser, true);
        }, 1000);
    }

    handleClear = async () => {
        const { clearPackages, getMyPackagesDetails, currentUser, headerType } = this.props;

        if (!clearPackages) {
            return;
        }

        const openPackage = this.getPackagesData().find(
            packageItem =>
                packageItem.entityType === headerType &&
                packageItem.status === "Open"
        );

        if (!openPackage) {
            return;
        }

        await clearPackages(openPackage);

        if (getMyPackagesDetails && currentUser) {
            await getMyPackagesDetails(currentUser, true);
        }

        this.setState({
            note: "",
            disableClearbtn: true,
        });
    };

    handleGenerate = async () => {
        const { headerType, generatePackage } = this.props;
        const { selectedFormat, note } = this.state;

        if (this.props.packageOperationInProgress || !generatePackage) {
            return;
        }
        const filteredData = this.getInitialPackageData(headerType);
        const hasFullCatalogue = Boolean(filteredData?.[0]?.searchCriteriaJson);
        const openPackage = this.getPackagesData().find(packageItem => packageItem.entityType === headerType && packageItem.status === "Open");

        if (!openPackage || (!hasFullCatalogue && (openPackage.packageItems?.length ?? 0) === 0)) {
            return;
        }

        if (!selectedFormat || selectedFormat === this.viewData[SELECT] || selectedFormat === SELECT) {
            return;
        }

        const packageToGenerate: IMyPackagesDetails = {
            ...openPackage,
            status: "In Progress",
            note,
            downloadFileFormat: selectedFormat,
        };

        await generatePackage(packageToGenerate);

        this.setState({
            disablebtn: true,
            note: "",
        });
    };
    
    handleSavePackage = async () => {
        const { addPackageNote, headerType } = this.props;
        const { note } = this.state;
        const myPackages = this.getPackagesData();
        const openPackage = myPackages.filter(x => x.entityType === headerType && x.status === "Open")[0];
        openPackage.note = note;
        this.setState({disableSavebtn: true});
        addPackageNote(openPackage);
    };
    render() {
        const {DownloadFileFormats,containerDetailsWindowComponentData,addFileToUpload,
            cleanUploadFilesState,destinations,droppedFiles,isDropZone,
            selectedFileSystem,setInDropZone,setProgressUploadFileProccess,storagePathItemData,refreshDirectory,removeAttachmentIfExists,addRepertoireAttachmentToState} = this.props;
        const { selectedFormat, lastModifiedDate, packageItemsCount, packageId, disablebtn,disableSavebtn, disableClearbtn } = this.state;

        const activePackage =
            this.getInitialPackageData(this.props.headerType)?.[0];

        const hasFullCatalogue = Boolean(
            activePackage?.searchCriteriaJson
        );

        const showContent = packageItemsCount > 0
        return (
            <>

                <div className="package-form">
                    <div className="paddingVerticalVeryLarge" style={{paddingBottom: '30px'}}>
                        {(containerDetailsWindowComponentData && containerDetailsWindowComponentData?.fields?.length > 0) && (<ScrollEventListenerWrapperContainerDetailsWindow
                            addFileToUpload={addFileToUpload}
                            cancelChanges={undefined}
                            cleanUploadFilesState={cleanUploadFilesState}
                            containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                            currentDirectory={"usage"}
                            destinations={destinations}
                            editingChanged={undefined}
                            fileMetadataChanged={undefined}
                            jobs={[]}
                            matchNow={undefined}
                            matchNowSubmit={undefined}
                            openDirectory={undefined}
                            pageContentIsActive={true}
                            distributions={undefined}
                            droppedFiles={droppedFiles}
                            isDropZone={true}
                            selectedFileSystem={selectedFileSystem}
                            setInDropZone={setInDropZone}
                            setProgressUploadFileProccess={setProgressUploadFileProccess}
                            storagePathItemData={storagePathItemData}
                            storagePaths={undefined}
                            refreshDirectory={refreshDirectory}
                            saveChanges={undefined}
                            saveState={undefined}
                            isRepertoireModule={true}
                            toggleSidebarCollapsed={undefined}
                            validationMessageChanged={undefined}
                            addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                            entityID={1}
                            entitySource={undefined}
                            removeAttachmentIfExists={removeAttachmentIfExists}
                            addDroppedFileRepertoire={undefined}
                            attachmentsDropped={undefined}
                            cleanDroppedFilesRepertoire={undefined}
                            setProgressUploadFileRepertoire={undefined}
                            component={UPLOAD_BULK_WORKS_PAGE_VIEW}
                            removeAttachmentMaintenanceScreen={undefined}
                            displayRemove={false}
                            paginationDetails={undefined}
                            updatePagination={undefined}
                            lookupValues={undefined}
                            tabs={undefined}
                            activeTab={undefined}
                            isProductAttachmentTypeNotRequired={true}
                            isProductAttachmentTypeOptional={false}
                            isWorkAttachmentTypeNotRequired={true}
                            isWorkAttachmentTypeOptional={false}
                            currentUserNameNumber={undefined}
                            renderDragFilesUpload={true}
                        />)}
                    </div>
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        <div className="bold-label form-group col-md-2 col-sm-5 col-xs-12">
                            {this.props.portalType === MATCHING_ENGINE && <div >
                                <label
                                    className={this.viewData[PACKAGE_ID_KEY]}><b>{this.viewData[PACKAGE_ID_KEY]}:</b></label>
                                {showContent && <div className="value">{packageId}</div>}
                            </div>}
                        </div>
                        <div className="bold-label form-group col-md-2 col-sm-5 col-xs-12">
                            <label
                                className={this.viewData[LASTMODIFIED_DATE_KEY]}><b>{this.viewData[LASTMODIFIED_DATE_KEY]}:</b></label>
                            {<div className="value">{lastModifiedDate}</div>}
                        </div>
                        <div className="bold-label form-group col-md-2 col-sm-5 col-xs-12">
                            <label
                                className={this.viewData[ITEM_COUNT_KEY]}><b>{this.viewData[ITEM_COUNT_KEY]}:</b></label>
                            <div className="value" data-testid="package-items-count">
                                {hasFullCatalogue
                                    ? this.viewData[FULL_CATALOGUE_TEXT]
                                    : packageItemsCount}
                            </div>
                        </div>
                        <div className="bold-label col-md-2 col-sm-5 col-xs-12">
                            <DropdownDataInput
                                label={this.viewData[DOWNLOAD_FILE_FORMAT_KEY]}
                                fieldName={this.viewData[DOWNLOAD_FILE_FORMAT_KEY]}
                                value={selectedFormat}
                                changeData={this.onSaveEditableFields}
                                options={DownloadFileFormats.map(format => ({
                                    code: format,
                                    description: format
                                }))}
                                allowNull={true}
                                readOnly={false}
                                isHidden={false}
                                isMandatory={getMandatoryFlag(this.props.myPackagesGeneralDataViewData, DOWNLOAD_FILE_FORMAT_KEY) }
                            />
                        </div>
                        <div className="bold-label form-group col-md-4 col-sm-5 col-xs-12">
                            <TextDataInput
                                placeholder={this.viewData[NOTE_PLACEHOLDER]}
                                label={this.viewData[NOTE_KEY]}
                                fieldName={NOTE_KEY}
                                changeData={this.onSaveEditableFields}
                                readOnly={false}
                                isHidden={false}
                                isMandatory={getMandatoryFlag(this.props.myPackagesGeneralDataViewData, NOTE_KEY)}
                                value={this.state.note}
                            />
                        </div>
                    </div>
                    <div>
                        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', marginTop: '10px'}}>
                            <div className="form-group col-md-2 col-sm-6 col-xs-12">
                                <button disabled={disableClearbtn} className="button btn-outline-defaultPrimary"
                                    onClick={this.handleClear}>{this.viewData[CLEAR_PACKAGE_BUTTON]}</button>
                            </div>
                            <div className="form-group col-md-2 col-sm-6 col-xs-12">
                                <button
                                    disabled={
                                        Boolean(this.props.packageOperationInProgress) || disablebtn ||
                                        (getMandatoryFlag(this.props.myPackagesGeneralDataViewData, DOWNLOAD_FILE_FORMAT_KEY) &&
                                            (!selectedFormat || selectedFormat === this.viewData[SELECT] || selectedFormat === SELECT)
                                        ) ||
                                        (getMandatoryFlag(this.props.myPackagesGeneralDataViewData, NOTE_KEY) &&
                                            !String(this.state.note ?? "").trim()
                                        )
                                    }
                                    className="button btn-defaultPrimary"
                                    onClick={this.handleGenerate}
                                >
                                    {this.props.packageOperationInProgress ? "Generating..." : this.viewData[GENERATE_FILE_PACKAGE]}
                                </button>
                            </div>
                            {this.props.portalType === MATCHING_ENGINE && <div className="form-group col-md-2 col-sm-6 col-xs-12">
                                <button disabled={disableSavebtn} className="button btn-defaultPrimary"
                                    onClick={this.handleSavePackage}>{this.viewData[SAVE_PACKAGE_BUTTON]}</button>
                            </div>}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
